// extracted by mini-css-extract-plugin
module.exports = {"container":"Routes_container__3eCjS","containerOuter":"Routes_containerOuter__405vD"};